(function ($) {
    $(function () {
        setTimeout(function () {
            const googleLinks = document.querySelectorAll("li.google-link a");
            if(!googleLinks) {
                return;
            }
            googleLinks.forEach(function (link) {
                link.setAttribute('target', '_blank');
                link.innerHTML = 'Preview This Book';
                document.querySelector('.google-link').style.display = 'block';
            });
        }, 2000);
    });
})(jQuery);


